import { SET_RESPUESTA } from "../actions/types";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_RESPUESTA:
      // PATRÓN ROBUSTO ADAPTADO:
      // Verificamos que payload exista y que tenga la propiedad 'Result'
      if (action.payload && action.payload.Result) {
        //console.log("Reducer Respuesta:", action.payload.Result);
        return { ...action.payload.Result };
      }

      // Si no viene 'Result' (ej: error de servidor), mantenemos el estado anterior
      // o podrías retornar { Retorno: -1, Mensaje: "Error" } si prefieres limpiar.
      return state;

    default:
      return state;
  }
};
